import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ArrowRight } from "@phosphor-icons/react";

const LINKS = [
    { label: "Come funziona", href: "#come-funziona" },
    { label: "Radar", href: "#radar" },
    { label: "Analisi", href: "#analisi" },
    { label: "Prezzi", href: "#prezzi" },
];

export const LandingNav = () => {
    const { user } = useAuth();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="landing-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/[0.08]"
                    : "bg-gradient-to-b from-black/50 to-transparent border-b border-transparent"
            }`}
        >
            <div className={`max-w-[1280px] mx-auto px-4 sm:px-6 md:px-10 flex items-center justify-between gap-2 transition-all duration-500 ${scrolled ? "h-16" : "h-[72px] sm:h-[92px]"}`}>
                <a href="#top" className="flex items-center shrink-0" data-testid="landing-nav-logo">
                    <img src="/logo-full.png" alt="Asta Intelligence" className={`w-auto mix-blend-screen transition-all duration-500 ${scrolled ? "h-12 sm:h-14" : "h-14 sm:h-[72px]"}`} />
                </a>
                <nav className="hidden md:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <a key={l.href} href={l.href} data-testid={`landing-nav-${l.href.slice(1)}`}
                           className="lp-body text-[13px] font-medium text-white/60 hover:text-white transition-colors">
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    {user ? (
                        <Link to="/dashboard" data-testid="landing-nav-dashboard"
                              className="h-9 px-4 inline-flex items-center gap-2 bg-[#FFFFFF] text-[#0A0A0A] text-[13px] font-semibold rounded-full hover:bg-[#00E599] transition-colors active:scale-95">
                            Dashboard <ArrowRight size={13} weight="bold" />
                        </Link>
                    ) : (
                        <>
                            <Link to="/login" data-testid="landing-nav-login"
                                  className="lp-body inline-flex h-9 px-2 sm:px-3 items-center text-[13px] font-semibold text-white/70 hover:text-white transition-colors">
                                Accedi
                            </Link>
                            <Link to="/register" data-testid="landing-nav-register"
                                  className="h-9 px-3.5 sm:px-4 inline-flex items-center gap-2 bg-[#FFFFFF] text-[#0A0A0A] text-[13px] font-semibold rounded-full hover:bg-[#00E599] transition-colors active:scale-95 whitespace-nowrap">
                                Inizia ora <ArrowRight size={13} weight="bold" />
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};
